import React from 'react';
import CancellationDetail from '../../../../components/templates/CancellationTemplate/CancellationDetail';

function TerminationDetailPage() {
	return <CancellationDetail />;
}

export default TerminationDetailPage;
